import { OnyxGray, Darker, color, Lighter3, GlitterGray, Lighter2 } from 'canoe';
import styled from 'styled-components';

export const Form = styled.form`
  padding: 16px;
  background-color: ${color(OnyxGray, Darker)};
  color: ${color(OnyxGray, Lighter3)};
  border-radius: 4px;
  border: 1px solid ${color(OnyxGray)};
`;

export const Label = styled.div`
  font-size: 12px;
  margin-bottom: 8px;
  text-transform: uppercase;
`;

export const Input = styled.input`
  height: 32px;
  padding: 7px;
  outline: none;
  backgorund: white;
  border: none;
`;

export const LinkInputContainer = styled.div`
  font-size: 12px;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  background-color: ${color(GlitterGray)};
  color: ${color(OnyxGray, Lighter2)};
  overflow: hidden;
  align-items: center;
`;

export const Button = styled.button<{ showBorder?: boolean }>`
  cursor: pointer;
  outline: none;
  appearance: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid ${({ showBorder }) => (showBorder ? color(OnyxGray, Lighter2) : 'transparent')};
  background: transparent;
  color: ${color(GlitterGray, Darker)};
  padding: 0 12px;
  min-width: 80px;

  &:focus {
    outline: none;
  }

  &:hover {
    background: ${color(OnyxGray)};
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 16px;

  button {
    margin-left: 8px;
  }
`;
